/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Error_RegistrationInputs */



/**
* | output |
* | --- |
* | "Registration failed." |
*
* @param {Auth_Error_RegistrationInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const auth_error_registration = /** @type {((inputs?: Auth_Error_RegistrationInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Error_RegistrationInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Inscription échouée.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Registro fallido.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Cadastro falhou.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Registrazione fallita.")
	return /** @type {LocalizedString} */ ("Registration failed.")
});